import GeneralAnalysis from '../generalAnalysis'
import HighLight from '../highlight'
import SectorPerformance from '../sectorPerformance'
import { AssetManagementEfficiency } from './assetManagementEfficiency'
import { BusinessGrowth } from './businessGrowth'
import { LiquiditySolvencyCoverage } from './liquiditySolvencyCoverage'
import { Profitability } from './profitability'

export const Corp = ({ settingsFS }) => {
  return (
    <>
      <HighLight />
      <GeneralAnalysis />
      <SectorPerformance />
      <LiquiditySolvencyCoverage settingsFS={settingsFS} />
      <AssetManagementEfficiency settingsFS={settingsFS} />
      <Profitability settingsFS={settingsFS} />
      <BusinessGrowth settingsFS={settingsFS} />
    </>
  )
}
